// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Timers-module__timerNameColumn-kl2Qm {
  width: 100%;
}

.nightbot-Timers-module__timerNameColumn-kl2Qm .nightbot-Timers-module__timerNameContainer-mXBxq {
    display: flex;
    gap: 4px;
    flex-direction: column;
  }

.nightbot-Timers-module__timerNameColumn-kl2Qm .nightbot-Timers-module__timerName-ufpBs {
    font-weight: bold;
  }

.nightbot-Timers-module__timerNameColumn-kl2Qm .nightbot-Timers-module__timerMessage-JcpBH {
    color: var(--text-secondary);
  }

.nightbot-Timers-module__timerIntervalHeader-_rO_3 {
  margin: auto 0 auto auto;
}

.nightbot-Timers-module__timerIntervalColumn-M5XUm {
  text-align: right;
  white-space: nowrap;
}

.nightbot-Timers-module__timerEnabledColumn-c3Vtg {
  text-align: center;
}

.nightbot-Timers-module__timerMessageColumn-C1IIe {
  width: 100%;
}

.nightbot-Timers-module__actionIcons-gcO6S {
  display: flex;
  gap: 4px;
  justify-content: right;
}

.nightbot-Timers-module__timerEnabledSwitchContainer-vftlM {
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Timers.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;AAeb;;AAbE;IACE,aAAa;IACb,QAAQ;IACR,sBAAsB;EACxB;;AAEA;IACE,iBAAiB;EACnB;;AAEA;IACE,4BAA4B;EAC9B;;AAGF;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".timerNameColumn {\n  width: 100%;\n\n  .timerNameContainer {\n    display: flex;\n    gap: 4px;\n    flex-direction: column;\n  }\n\n  .timerName {\n    font-weight: bold;\n  }\n\n  .timerMessage {\n    color: var(--text-secondary);\n  }\n}\n\n.timerIntervalHeader {\n  margin: auto 0 auto auto;\n}\n\n.timerIntervalColumn {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.timerEnabledColumn {\n  text-align: center;\n}\n\n.timerMessageColumn {\n  width: 100%;\n}\n\n.actionIcons {\n  display: flex;\n  gap: 4px;\n  justify-content: right;\n}\n\n.timerEnabledSwitchContainer {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timerNameColumn": `nightbot-Timers-module__timerNameColumn-kl2Qm`,
	"timerNameContainer": `nightbot-Timers-module__timerNameContainer-mXBxq`,
	"timerName": `nightbot-Timers-module__timerName-ufpBs`,
	"timerMessage": `nightbot-Timers-module__timerMessage-JcpBH`,
	"timerIntervalHeader": `nightbot-Timers-module__timerIntervalHeader-_rO_3`,
	"timerIntervalColumn": `nightbot-Timers-module__timerIntervalColumn-M5XUm`,
	"timerEnabledColumn": `nightbot-Timers-module__timerEnabledColumn-c3Vtg`,
	"timerMessageColumn": `nightbot-Timers-module__timerMessageColumn-C1IIe`,
	"actionIcons": `nightbot-Timers-module__actionIcons-gcO6S`,
	"timerEnabledSwitchContainer": `nightbot-Timers-module__timerEnabledSwitchContainer-vftlM`
};
export default ___CSS_LOADER_EXPORT___;
